export default function Loading({
  className,
  trackClassName,
  strokeWidth = 4,
}: {
  className?: string;
  trackClassName?: string;
  strokeWidth?: number;
}) {
  return (
    <svg
      width="20"
      height="20"
      className={`animate-spin ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className={trackClassName || 'stroke-current opacity-25'}
        cx="12"
        cy="12"
        r="10"
        strokeWidth={strokeWidth}
      />
      <path
        stroke="currentColor"
        strokeWidth={strokeWidth}
        fill="none"
        d="M 12 2 A 10 10 0 0 1 20.66 17"
        strokeLinecap="round"
      />
    </svg>
  );
}
